<template>
  <div class="learning">
    <section class="user-info">
      <div class="container">
        <div class="row">
          <div class="col-lg-5 col-sm-12">
            <div class="user-data">
              <div class="user-photo">
                <img :src="userPhoto" alt />
              </div>
              <div class="user-name-box">
                <p class="user-name">{{userName}}</p>
                <p class="user-introduce">{{userInfo?userInfo:'这家伙很懒啊'}}</p>
              </div>
            </div>
          </div>
          <div class="col-lg-7 col-sm-12">
            <ul class="user-other">
              <!-- <li>
                <h2 class="score-count" @click="integralMall">{{scoreCount}}</h2>
                <p>我的积分</p>
                <div
                  class="integral-mall-btn div-btn"
                  @mouseover="integralMallShow"
                  @mouseout="integralMallHide"
                >去兑换</div>
                <div class="qrcode-store" v-if="qrcodeStoreFlag">
                  <img src="@/image/qrcode-store.jpg" alt />
                </div>
              </li> -->
              <li>
                <h2>{{gloryCount}}</h2>
                <p>我的荣誉</p>
                <div class="div-btn" @click="HonorWallFn">荣誉墙</div>
              </li>
              <li>
                <h2 class="my-help-total">
                  {{askCount}}
                  <!-- <span v-if="unreadFlag">{{unreadFlag?(unreadFlag > 99 ? '99+': unreadFlag):""}}新回答</span> -->
                </h2>
                <p>我的问答</p>
                <div class="div-btn" @click="myHelpFn">查看</div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <section class="learing-content-box">
      <div class="container">
        <ul class="learning-nav">
          <li class="recent-nav" :class="{'select':isShowLearningBox}" @click="contShowChange('learning')">
            <i></i>
            <span>最近学习</span>
          </li>
          <li class="course-nav" :class="{'select':isShowCourseBox}" @click="contShowChange('course')">
            <i></i>
            <span>我的课程</span>
          </li>
          <li class="scene-nav" :class="{'select':isShowSceneBox}" @click="contShowChange('scene')">
            <i></i>
            <span>我的路线</span>
          </li>
        </ul>
        <div class="learning-cont">
          <!-- 最近学习 -->
          <div class="recent-learning-box" v-if="isShowLearningBox">
            <div class="recent-learning" id="recent-learning" v-if="isShowLearning">
              <div class="course-banner">
                <img :src="currCourseData.courseBanner" alt />
              </div>
              <div class="course-info">
                <div class="courseName-box">
                  <span class="course-menuName">{{currCourseData.menuName}}</span>
                  <span class="course-name">{{currCourseData.courseName}}</span>
                </div>
                <div class="course-barrier-info">
                  <span class="barrier-teacher">{{currCourseData.teacherName}}</span>
                  <span class="barrier-num">{{currCourseData.barrierCount}}个关卡</span>
                </div>
                <div
                  class="continue-box"
                  :title="currCourseData.currCheck"
                >当前进度：{{currCourseData.currCheck}}</div>
                <div class="barrier-progress">
                  <div class="progress-bar-box">
                    <div class="progress-bar-bg">
                      <div class="curr-progress" ref="currProgress"></div>
                    </div>
                    <span class="curr-progress-num">已学习{{currCourseData.currProgress}}%</span>
                  </div>
                </div>
              </div>
              <span class="continue" @click.stop="toBarrier()">继续学习</span>
            </div>
          </div>
          <!-- 我的课程 -->
          <div class="my-course-box" v-else-if="isShowCourseBox">
            <div class="study-state-box">
              <ul class="study-state">
                <li :class="learnStatus === 1?'select' : ''" @click="setLearnStatus(1)">学习中</li>
                <li :class="learnStatus === 2?'select' : ''" @click="setLearnStatus(2)">已学完</li>
              </ul>
            </div>
            <div
              class="cont-list-box"
              :class="isShowLearning?'':'m-top'"
              v-if="subjectList && subjectList.length > 0"
            >
              <div class="container">
                <div class="row">
                  <div class="col-lg-12">
                    <div class="screen-box">
                      <div class="screen-tips">学科筛选</div>
                      <ul class="screen-list">
                        <li @click="subjectChange()" :class="!currMenuId?'select':''">全部</li>
                        <li
                          v-for="(item,index) in subjectList"
                          :key="index"
                          :class="item && item.isSelect?'select':''"
                          @click="subjectChange(item.menuId)"
                        >{{item.menuName}}</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <List :listArr="list" v-if="isHasList"></List>
              <div class="no-data" v-else>
                <img src="@/image/course/pic-noData.png" alt />
                <p>
                  凄凄惨惨戚戚，还未学习任何互动
                  <br />课程，去
                  <router-link to="/">课程库</router-link>
                </p>
              </div>

              <div class="pagination-box" v-if="pageData.total > pageData.pageSize">
                <el-pagination
                  background
                  @current-change="currentChange"
                  layout="prev, pager, next"
                  :total="pageData.total"
                  :page-size="pageData.pageSize"
                  :current-page.sync="pageData.page"
                ></el-pagination>
              </div>
            </div>
            <div
              class="learning-default"
              v-else-if="isShowLearning && subjectList && subjectList.length == 0"
            >
              <div class="default-cont">
                <img src="@/image/course/pic-noData.png" alt />
                <p>{{learnStatus == 2?'没有发现已学完的课程~':'没有发现学习中的课程~'}}~</p>
              </div>
            </div>
            <div class="learning-default" v-else-if="!isShowLearning">
              <div class="default-cont">
                <img src="@/image/course/pic-noData.png" alt />
                <p>
                  凄凄惨惨戚戚，还未学习任何互动
                  <br />课程，去
                  <router-link to="/course">课程库</router-link>
                </p>
              </div>
            </div>
          </div>
          <!-- 我的路线 -->
          <div class="my-scene-box" v-else-if="isShowSceneBox">
            <div class="scene-default" v-if="isShowScenDefault">
              <div class="default-cont">
                <img src="@/image/course/pic-noData.png" alt="">
                <p>没有订阅任何学习路线哦~ <router-link to="/scene/">去看看</router-link></p>
              </div>
            </div>
            <SceneList :courseList="sceneData" class="SceneList" :key="Math.random()*100" v-else />
          </div>
        </div>
      </div>
    </section>


    <div class="right-fixed-box">
      <div
        class="mobile-study"
        :class="isMobileFlag === true && isShowQrCode === true?'blueColor':''"
        @mouseover="showMobile"
        @mouseout="hidePopup"
      ></div>
      <div class="line"></div>
      <div
        class="problem-btn"
        :class="isMobileFlag === false && isShowQrCode === true?'blueColor':''"
        @mouseover="showProblem"
        @mouseout="hidePopup"
      ></div>
      <div
        class="right-qrcode-box"
        v-if="isShowQrCode"
        :class="isMobileFlag === false?'popup-top':''"
      >
        <img class="a1" src="@/image/course/xcx-qrcode.jpg" alt v-if="isMobileFlag" />
        <img class="a2" src="@/image/course/gzh-qrcode.jpg" alt v-else />
        <p v-html="qrcodeText"></p>
      </div>
    </div>
    <HonorWall
      :show="honorData.show"
      :data="honorData.data"
      @closePopup="closePopup"
      :qrCode="honorData.qrCode"
    />
  </div>
</template>

<script>
import("@/assets/style.css");
import { Pagination } from "element-ui";
import { zhugeTrack } from "@/../public/public";
import { isMobile } from "@/../public/public";
import { axios } from "@/../api/init";
import List from "@/components/indexComponents/list";
import HonorWall from "@/components/indexComponents/honor-wall";
import SceneList from "@/components/indexComponents/sceneList";
export default {
  name: "learning",
  components: {
    List,
    [Pagination.name]: Pagination,
    HonorWall,
    SceneList
  },
  data() {
    return {
      currCourseData: {
        courseName: "", // 最近学习课程名称
        currCheck: "", // 最近学习关卡名称
        currCourseId: "", // 最近学习课程ID
        currBarrierId: "", // 最近学习关卡ID
        currChapterId: "", // 最近学习章节ID
        currProgress: 0, // 当前进度百分比
        barrierType: "", // 最近学习关卡类型
        barrierCount: "", // 最近学习关卡数
        menuName: "", // 最近学习学科名称
        teacherName: "", // 最近学习老师名称
        courseBanner: "", // 最近学习课程banner图
      },
      currMenuId: "",
      userPhoto: "",
      userName: "",
      userInfo: "",
      studentId: "",
      isShowLearning: false,
      qrcodeStoreFlag: false, // 积分商城二维码
      sign: "",
      isShowQrCode: false,
      isMobileFlag: "", // 右侧二维码判断
      qrcodeText: "扫一扫哦",
      scoreCount: 0, // 积分总数
      gloryCount: 0, // 个人荣誉总数
      askCount: 0, // 我的问答总数
      unreadFlag: 0, // 我的问答未读
      list: {},
      isHasList: true,
      subjectList: [], // 学习中的学科列表
      learnStatus: 1, // 课程学习状态  1、学习中 0、已学完
      isShowLearningBox:true,
      isShowCourseBox:false,
      isShowSceneBox:false,
      sceneData:[], // 我的路线内容
      isShowScenDefault: false, // 学习路线 缺省
      // 分页数据
      pageData: {
        pageSize: 6,
        page: 1,
        total: 0,
      },
      // 荣誉墙
      honorData: {
        show: false,
        data: {},
        qrCode: "",
      },
    };
  },
  created() {
    if (isMobile()) {
      window.location.href = "/qrcode.html#/";
    }
  },
  mounted() {
    this.IsAlive();
  },
  methods: {
    IsAlive() {
      axios({
        url: VUE_APP_BASE_PATH_ONLINE + "/online/user/isAlive",
        method: "GET",
      }).then((res) => {
        if (res.data.success) {
          let result = res.data.resultObject;
          let sign = this.getSign(); //解析cookie中的sign
          localStorage.setItem("sign", sign);
          localStorage.setItem("studentId", res.data.resultObject.id);
          this.sign = localStorage.getItem("sign");
          this.studentId = localStorage.getItem("studentId");
          this.userPhoto = result.smallHeadPhoto;
          this.userName = result.name;
          this.userInfo = result.info;
          this.getLearn();
          this.getSubjectList();
          this.getAchievementData();
          this.getSceneData()
          zhugeTrack("Web_进入当前学习页");
        } else {
          localStorage.removeItem("sign");
          localStorage.removeItem("studentId");
          this.$router.push({
            path: "/",
          });
        }
      });
    },
    getCookie(name) {
      //读取cookie
      var arr = document.cookie.match(
        new RegExp("(^| )" + name + "=([^;]*)(;|$)")
      );
      if (arr != null) return unescape(arr[2]);
      return null;
    },
    // 获取sign
    getSign() {
      var cookie = this.getCookie("_uc_t_");
      if (cookie != null) {
        var arr = cookie.split(";");
        return arr[2];
      }
      return null;
    },
    // 导航内容切换
    contShowChange(type){
      if(type === 'learning'){
        if(this.isShowLearningBox){
          return
        }
        this.getLearn()
        this.isShowLearningBox = true
        this.isShowCourseBox = false
        this.isShowSceneBox = false
      }else if(type === 'course'){
        if(this.isShowCourseBox){
          return
        }
        this.isShowLearningBox = false
        this.isShowCourseBox = true
        this.isShowSceneBox = false
      }else if(type === 'scene'){
        if(this.isShowSceneBox){
          return
        }
        this.isShowLearningBox = false
        this.isShowCourseBox = false
        this.isShowSceneBox = true
      }
    },
    currentChange(val) {
      this.pageData.page = val;
      this.getLearningList(this.currMenuId);
    },
    // 已订阅的学习路线
    async getSceneData(){
      let params = {
        studentId: this.studentId,
        sign: this.sign,
      };
      let res = await axios({
        url:
          VUE_APP_BASE_PATH_ONLINE_APP + "/interactive-course/scene/subscribed",
        method: "GET",
        params: params,
      });
      if(res.data.status === 200){
        this.sceneData = res.data.result
        if((this.sceneData && this.sceneData.length == 0) || !this.sceneData){
          this.isShowScenDefault = true
        }
      }
    },
    // 最近学习-目录页跳转
    toCatelog() {
      window.location.href = "/?courseId=" + this.currCourseData.currCourseId;
      zhugeTrack("Web_当前学习页-点击最近学习", {
        按钮名称: "整个卡片",
      });
    },
    toBarrier() {
      zhugeTrack("Web_当前学习页-点击最近学习", {
        按钮名称: "继续学习",
      });
      let Type = this.currCourseData.barrierType == 1 ? 'program' : this.currCourseData.barrierType == 2 ? 'browse' : 'mutual'
      let currCourseId = this.currCourseData.currCourseId
      let currBarrierId = this.currCourseData.currBarrierId
      let currChapterId = this.currCourseData.currChapterId
      window.open(`/barrier.html#/${Type}?courseId=${currCourseId}&barrierId=${currBarrierId}&chapterId=${currChapterId}&source=true`)
    },
    // 切换学习状态
    setLearnStatus(num) {
      if (num === this.learnStatus) {
        return;
      } else {
        this.currMenuId = "";
        this.learnStatus = num;
        this.pageData.page = 1
        this.getSubjectList();
      }
    },
    // 最近学习
    getLearn() {
      axios({
        url: VUE_APP_BASE_PATH_ONLINE_APP + "/interactive-course/recent-learn",
        method: "GET",
        params: {
          studentId: this.studentId,
          sign: this.sign,
        },
      }).then((res) => {
        let data = res.data;
        if (res.data.status === 200) {
          if (data.result) {
            this.currCourseData = {
              courseName: data.result.courseName,
              currCourseId: data.result.courseId,
              currCheck: data.result.barrierName,
              barrierType: data.result.barrierType,
              barrierCount: data.result.barrierCount,
              currBarrierId: data.result.barrierId,
              currChapterId: data.result.chapterId,
              currProgress: parseInt(data.result.learnProportion),
              menuName: data.result.menuName,
              teacherName: data.result.lecturer,
              courseBanner: data.result.courseImg,
            };
            this.isShowLearning = true;
            // 进度条样式
            this.$nextTick(() => {
              this.$refs.currProgress.style.width = 200 * (this.currCourseData.currProgress / 100) + "px";
            });
          } else {
            this.isShowLearning = false;
          }
        }
      });
    },
    // 获取学习中的学科
    async getSubjectList() {
      let params = {
        learnStatus: this.learnStatus,
        studentId: this.studentId,
        sign: this.sign,
      };
      let res = await axios({
        url:
          VUE_APP_BASE_PATH_ONLINE_APP + "/interactive-course/learning-menus",
        method: "GET",
        params: params,
      });
      if (res.data.status === 200) {
        if (res.data.result && res.data.result.length > 0) {
          this.subjectList = res.data.result;
          this.subjectList.forEach((val) => {
            val.isSelect = false;
          });
          // this.subjectList[0].isSelect = true
          this.getLearningList();
        } else {
          this.subjectList = [];
        }
      }
    },
    // 学科切换
    async subjectChange(id) {
      this.currMenuId = id;
      this.subjectList.forEach((val) => {
        if (val.menuId == id) {
          val.isSelect = true;
        } else {
          val.isSelect = false;
        }
      });
      this.pageData.page = 1
      this.getLearningList(id);
    },
    // 学习中的课程
    async getLearningList(id) {
      let params = {
        page: this.pageData.page,
        pageSize: this.pageData.pageSize,
        learnStatus: this.learnStatus,
        menuId: id ? id : "",
        studentId: this.studentId,
        sign: this.sign,
      };
      let res = await axios({
        url: VUE_APP_BASE_PATH_ONLINE_APP + "/interactive-course/learning",
        method: "GET",
        params: params,
      });

      if (res.data.status === 200) {
        let data = res.data;
        if (data.result.list && data.result.list.length > 0) {
          this.isHasList = true;
          let obj = {};
          this.pageData.total = data.result.total;
          data.result.list.forEach((val) => {
            if (val.menuName == null) {
              val.menuName = "其它";
            }
          });
          if (this.learnStatus === 1) {
            obj.groupName = "学习中的课程";
          } else {
            obj.groupName = "已学完的课程";
          }
          obj.courses = data.result.list;
          this.list = obj;
        } else {
          this.isHasList = false;
        }
      }
    },
    // 右侧悬浮二维码
    showMobile() {
      this.isShowQrCode = true;
      this.isMobileFlag = true;
      this.qrcodeText = "扫小程序二维码在<br/>手机端学习";
      zhugeTrack("Web_当前学习页-右侧悬浮", {
        按钮名称: "移动学习",
      });
    },
    showProblem() {
      this.isShowQrCode = true;
      this.isMobileFlag = false;
      this.qrcodeText = "可以关注公众号进行留言提问或反馈哦";
      zhugeTrack("Web_当前学习页-右侧悬浮", {
        按钮名称: "提问反馈",
      });
    },
    hidePopup() {
      this.isShowQrCode = false;
    },
    // 微信小程序二维码
    async wxQRcode() {
      let params = {
        page: "pages/index/index",
        scene: "origin=shareGloryWall",
        sceneType: "code",
      };
      let res = await axios({
        url: VUE_APP_BASE_PATH_WEIXIN + "/mini/qrcode/xcx/create",
        method: "POST",
        params: params,
      });
      if (res.status == 200) {
        if (res.data.result) {
          this.honorData.qrCode = "data:image/jpg;base64," + res.data.result;
        } else {
          this.honorData.qrCode = "";
        }
      }
    },
    // 荣誉墙
    async HonorWallFn() {
      let params = {
        studentId: this.studentId,
        sign: this.sign,
      };
      let res = await axios({
        url: VUE_APP_BASE_PATH_ONLINE_APP + "/interactive-course/glory",
        method: "GET",
        params: params,
      });
      if (res.data.status == 200) {
        this.honorData.data = res.data.result;
        this.honorData.show = true;
        this.wxQRcode();
        zhugeTrack("Web_当前学习页-点击荣誉墙");
      }
    },
    // 积分商城
    integralMall() {
      window.open(
        VUE_APP_BASE_PATH_XUEXI + "/personcenter.html?anchor=myintegral"
      );
      zhugeTrack("Web_当前学习页-点击积分商城");
    },
    integralMallShow() {
      this.qrcodeStoreFlag = true;
    },
    integralMallHide() {
      this.qrcodeStoreFlag = false;
    },
    // 我的问答
    myHelpFn() {
      this.$router.push({
        path: "/myHelp",
        query: {
          myHelp: true,
        },
      });
      zhugeTrack("Web_当前学习页-点击我的问答");
    },
    closePopup() {
      this.honorData.show = false;
    },
    // 成就数据
    async getAchievementData() {
      let params = {
        studentId: this.studentId,
        sign: this.sign,
      };
      let res = await axios({
        url: VUE_APP_BASE_PATH_ONLINE_APP + "/interactive-course/achievement",
        method: "GET",
        params: params,
      });
      if (res.data.status == 200) {
        this.scoreCount = res.data.result.scoreCount;
        this.gloryCount = res.data.result.gloryCount;
        this.unreadFlag = res.data.result.unReadReplyCount;
        this.askCount = res.data.result.askCount;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.learning {
  width: 100%;
  // 学员信息
  .user-info {
    width: 100%;
    background-image: url(../image/learning/pic-learning-bg-01.png);
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    .container {
      max-width: 1200px;
      margin: 0 auto;
    }
    .user-data {
      width: 400px;
      padding: 60px 0 0;
      display: flex;
      .user-photo {
        width: 100px;
        height: 100px;
        margin-right: 20px;
        img {
          width: 92px;
          height: 92px;
          border: 4px solid #fff;
          border-radius: 50%;
        }
      }
      .user-name-box {
        .user-name {
          font-family: PingFangSC-Semibold;
          font-size: 30px;
          color: #ffffff;
          line-height: 42px;
          margin: 0;
        }
        .user-introduce {
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #ffffff;
          margin: 22px 0 0;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical;
        }
      }
    }
    .user-other {
      width: 400px;
      margin: 0 0 0 50px;
      display: flex;
      justify-content: space-between;
      padding: 48px 0 50px;
      > li {
        text-align: center;
        position: relative;
        h2 {
          font-family: PingFangSC-Semibold;
          font-size: 30px;
          color: #e88f34;
        }
        // 求助总数
        .my-help-total {
          display: inline-block;
          position: relative;
          margin: 0;
          // 求助未读
          span {
            white-space: nowrap;
            padding: 0 6px;
            height: 18px;
            line-height: 18px;
            display: block;
            position: absolute;
            border-radius: 9px;
            text-align: center;
            transform: scale(0.8);
            top: -12px;
            left: 90%;
            color: #fff;
            background: #e85334;
            font-size: 12px;
          }
        }
        .score-count {
          cursor: pointer;
          &:hover {
            opacity: 0.8;
          }
        }
        p {
          font-size: 14px;
          color: #ffffff;
          margin: 16px 0;
        }
        .div-btn {
          margin: 0 auto;
          width: 60px;
          height: 28px;
          background: #25c48b;
          border-radius: 4px;
          font-family: PingFangSC-Regular;
          font-size: 12px;
          color: #ffffff;
          line-height: 28px;
          cursor: pointer;
          &:hover {
            background: #28d899;
          }
        }
        .qrcode-store {
          position: absolute;
          bottom: -150px;
          left: 50%;
          transform: translateX(-50%);
          width: 140px;
          height: 140px;
          padding: 5px;
          box-sizing: border-box;
          background: #fff;
          z-index: 5;
          border-radius: 8px;
          box-shadow: 0px 2px 15px 0px rgba(0, 0, 0, 0.14);
          img {
            width: 130px;
            height: 130px;
          }
        }
      }
    }

    @media (max-width: 500px) {
      .user-other {
        width: 100% !important;
      }
    }

    @media (max-width: 1400px) {
      .user-data {
        margin: 0 auto;
      }
    }

    @media (max-width: 991px) {
      .user-data {
        width: 100%;
        justify-content: center;
      }
      .user-other {
        margin: 0 auto;
      }
    }
  }

  // 学习中的内容
  .learing-content-box {
    margin-top: 50px;
    .container {
      display: flex;
      // 左侧导航
      .learning-nav {
        width: 230px;
        height: 520px;
        background-color: #ffffff;
        border-radius: 4px;
        padding: 40px 0 0;
        li {
          height: 44px;
          padding-left: 40px;
          margin-bottom: 10px;
          position: relative;
          cursor: pointer;
          i {
            width: 20px;
            height: 20px;
            display: inline-block;
            vertical-align:middle;
          }
          span {
            line-height: 44px;
            font-family: PingFangSC-Semibold;
            font-size: 14px;
            display: inline-block;
            vertical-align:middle;
            line-height: 44px;
            margin-left: 10px;
          }
          &:hover{
            background: #f1fbf8;
            span {
              color: #25c48b;
            }
            &:after {
              content: "";
              display: block;
              width: 6px;
              height: 100%;
              background: #25c48b;
              position: absolute;
              left: 0;
              top: 0;
            }
          }
        }
        .recent-nav{
          i{
            width: 21px;
            height: 22px;
            background:url(../image/learning/icon-recent-nav.png);
            background-repeat:no-repeat;
            background-size: 100% 100%;
          }
          &:hover{
            i{
              background:url(../image/learning/icon-recent-nav-hover.png);
              background-repeat:no-repeat;
              background-size: 100% 100%;
            }
          }
        }
        .course-nav{
          i{
            width: 18px;
            height: 22px;
            background:url(../image/learning/icon-course-nav.png);
            background-repeat:no-repeat;
            background-size: 100% 100%;
          }
          span{
            margin-left: 13px;
          }
          &:hover{
            i{
              background:url(../image/learning/icon-course-nav-hover.png);
              background-repeat:no-repeat;
              background-size: 100% 100%;
            }
          }
        }
        .scene-nav{
          i{
            width: 20px;
            height: 20px;
            background:url(../image/learning/icon-scene-nav.png);
            background-repeat:no-repeat;
            background-size: 100% 100%;
          }
          span{
            margin-left: 11px;
          }
          &:hover{
            i{
              background:url(../image/learning/icon-scene-nav-hover.png);
              background-repeat:no-repeat;
              background-size: 100% 100%;
            }
          }
        }
        .select {
          background: #f1fbf8;
          span {
            color: #25c48b;
          }
          &:after {
            content: "";
            display: block;
            width: 6px;
            height: 100%;
            background: #25c48b;
            position: absolute;
            left: 0;
            top: 0;
          }
        }
        .recent-nav.select{
          i{
            background:url(../image/learning/icon-recent-nav-hover.png);
            background-repeat:no-repeat;
            background-size: 100% 100%;
          }
        }
        .course-nav.select{
          i{
            background:url(../image/learning/icon-course-nav-hover.png);
            background-repeat:no-repeat;
            background-size: 100% 100%;
          }
        }
        .scene-nav.select{
          i{
            background:url(../image/learning/icon-scene-nav-hover.png);
            background-repeat:no-repeat;
            background-size: 100% 100%;
          }
        }
      }

      // 内容
      .learning-cont {
        flex: 1;
        margin-left: 30px;

        // 最近学习
        .recent-learning-box{
          .recent-learning {
            padding: 30px;
            border-radius: 4px;
            background-color: #ffffff;
            width: 100%;
            display: flex;
            position: relative;
            box-sizing: border-box;
            overflow: hidden;
            .course-banner {
              width: 276px;
              height: 168px;
              overflow: hidden;
              position: relative;
              img {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                height: 100%;
                display: block;
              }
            }
            .course-info {
              flex: 1;
              margin-left: 30px;
              position: relative;
              .courseName-box {
                // display: flex;
                .course-menuName {
                  padding: 0 10px;
                  height: 28px;
                  line-height: 28px;
                  font-family: PingFangSC-Regular;
                  font-size: 15px;
                  color: #25c48b;
                  background: #ebf4f0;
                  vertical-align: middle;
                  border-radius: 4px;
                  max-width: 150px;
                  text-overflow: ellipsis;
                  overflow: hidden;
                  white-space: nowrap;
                  float: left;
                  margin-right: 10px;
                }
                .course-name {
                  display: inline;
                  margin: 0 0 0 15px;
                  font-family: PingFangSC-Semibold;
                  font-size: 22px;
                  color: #2a3c60;
                  line-height: 28px;
                  text-overflow: -o-ellipsis-lastline;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-line-clamp: 2;
                  line-clamp: 2;
                  -webkit-box-orient: vertical;
                }
              }
              // 课程信息
              .course-barrier-info {
                margin-top: 18px;
                span {
                  font-family: PingFangSC-Regular;
                  font-size: 16px;
                  line-height: 22px;
                }
                .barrier-teacher {
                  color: #818896;
                }
                .barrier-num {
                  margin-left: 50px;
                  color: #1d3156;
                }
              }
              // 当前进度
              .continue-box {
                width: 100%;
                margin-top: 38px;
                height: 20px;
                font-family: PingFangSC-Regular;
                font-size: 14px;
                color: #262626;
                line-height: 20px;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
              }
              // 进度条
              .barrier-progress {
                .progress-bar-box {
                  margin-top: 7px;
                  height: 20px;
                  .progress-bar-bg {
                    width: 200px;
                    height: 6px;
                    background: #f5f6f6;
                    border-radius: 3px;
                    position: relative;
                    display: inline-block;
                    vertical-align: middle;
                    .curr-progress {
                      transition: width 0.5s ease;
                      position: absolute;
                      width: 0px;
                      max-width: 200px;
                      height: 6px;
                      top: 0;
                      left: 0;
                      background: #e88f34;
                      border-radius: 3px;
                    }
                  }
                  .curr-progress-num {
                    display: inline-block;
                    font-family: PingFangSC-Regular;
                    font-size: 16px;
                    color: #e88f34;
                    letter-spacing: 0;
                    margin-left: 20px;
                    line-height: 22px;
                    vertical-align: middle;
                  }
                }
              }
            }
            // 继续学习
            .continue {
              position: absolute;
              right: 30px;
              bottom: 30px;
              width: 96px;
              height: 34px;
              background: #e88f34;
              border-radius: 4px;
              text-align: center;
              line-height: 34px;
              color: #fff;
              font-family: PingFangSC-Regular;
              font-size: 14px;
              cursor: pointer;
              &:hover {
                background: #fa814c;
                color: #fff;
              }
            }
          }
        }

        // 我的课程
        .my-course-box{
          background: #fff;
          padding: 30px 10px 40px;
          border-radius: 4px;
          background-color: #ffffff;
          .study-state-box {
            //  学习状态切换
            .study-state {
              margin: 0 auto;
              display: flex;
              justify-content: center;
              li {
                width: 68px;
                min-width: auto;
                padding: 10px 1px;
                line-height: 18px;
                font-size: 16px;
                color: #262626;
                margin: 0 10px;
                cursor: pointer;
                box-sizing: border-box;
                transition: all 0.25s;
                text-align: center;
                &:hover {
                  color: #fff;
                  background-color: #25c48b;
                  border-radius: 4px;
                }
              }
              .select {
                color: #fff;
                background-color: #25c48b;
                border-radius: 4px;
              }
            }
          }
          .cont-list-box {
            box-sizing: border-box;
            margin: 0 auto;
            margin-top: 40px;
            border-radius: 22px;
            position: relative;
            // 学科筛选
            .screen-box {
              width: 100%;
              display: flex;
              justify-content: flex-end;
              padding-bottom: 20px;
              .screen-tips {
                display: inline-block;
                font-size: 14px;
                color: #25c48b;
                line-height: 39px;
                min-width: 60px;
              }
              .screen-list {
                max-width: 100%;
                margin-left: 20px;
                display: flex;
                flex-flow: row wrap;
                li {
                  margin: 0 10px 20px;
                  font-family: PingFangSC-Regular;
                  font-size: 14px;
                  color: #a3a4a6;
                  cursor: pointer;
                  padding: 8px 18px;
                  border-radius: 19px;
                  &:hover {
                    color: #25c48b;
                  }
                }
                .select {
                  color: #25c48b;
                }
                li:last-child {
                  margin-right: 0;
                }
              }
            }

            .no-data {
              padding: 160px 0;
              text-align: center;
              img {
                width: 153px;
              }
              p {
                margin-top: 30px;
                color: #abafbd;
                font-size: 12px;
                line-height: 20px;
                a {
                  color: #0b2fb5;
                }
              }
            }
            @media screen and (min-width: 1200px) {
              .container {
                max-width: 1200px;
              }
            }
          }
        }


        // 我的路线
        .my-scene-box{
          height: 100%;
          .SceneList{
            padding:0;
            /deep/ .scene-box{
              border:0 !important;
            }
            @media (max-width:991px) {
              /deep/ .scene-box{
                display: block;
                .scene-box-right{
                  margin-top: 20px;
                  padding:0;
                }
              }
            }
          }

          // 缺省
          .scene-default{
            height: 100%;
            background: #fff;
            border-radius: 4px;
            position: relative;
            .default-cont{
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%,-50%);
              text-align: center;
              p{ 
                margin-top: 30px;
                color: #abafbd;
                font-family: PingFangSC-Regular;
                font-size: 12px;
                line-height: 20px;
                a{
                  color: #25c48b;
                  &:hover{
                    color: #28D899;
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  // 右侧悬浮
  .right-fixed-box {
    width: 60px;
    position: fixed;
    border: 1px solid #dcdfe4;
    border-radius: 4px;
    top: 50%;
    right: 30px;
    transform: translateY(-50%);
    background: #fff;
    .line {
      width: 40px;
      height: 1px;
      background: #dcdfe4;
      margin: 0 auto;
    }
    .mobile-study,
    .problem-btn {
      width: 100%;
      height: 70px;
      box-sizing: border-box;
      border-radius: 10px;
      line-height: 17px;
      font-size: 12px;
      background: #fff;
      cursor: pointer;
      -moz-user-select: none;
      -khtml-user-select: none;
      user-select: none;
      color: #333;
    }
    .mobile-study {
      background: url(../image/learning/icon-move.png);
      background-size: 39px 40px;
      background-repeat: no-repeat;
      background-position: center;
      &:hover {
        background: url(../image/learning/icon-move-h.png);
        background-size: 39px 40px;
        background-repeat: no-repeat;
        background-position: center;
      }
    }
    .problem-btn {
      background: url(../image/learning/icon-question.png);
      background-size: 40px 41px;
      background-repeat: no-repeat;
      background-position: center;
      &:hover {
        background: url(../image/learning/icon-question-h.png);
        background-size: 40px 41px;
        background-repeat: no-repeat;
        background-position: center;
      }
    }
    .blueColor {
      color: rgba(11, 47, 181, 1);
    }
    .right-qrcode-box {
      width: 150px;
      background: #fff;
      border-radius: 10px;
      box-shadow: 0px 2px 20px 0px rgba(10, 20, 58, 0.08);
      position: absolute;
      top: 0px;
      left: -163px;
      padding: 15px 15px 10px;
      box-sizing: border-box;
      img {
        width: 120px;
        height: 120px;
        display: block;
      }
      p {
        margin: 5px auto 0;
        display: block;
        width: 115px;
        text-align: center;
        color: #999;
        font-size: 12px;
      }
      &::after {
        position: absolute;
        top: 15px;
        right: -5px;
        content: "";
        display: block;
        width: 0;
        height: 0;
        border-left: 5px solid #fff;
        border-bottom: 3.5px solid transparent;
        border-top: 3.5px solid transparent;
      }
    }
    .popup-top {
      top: 60px;
    }
  }

  @media (max-width: 1400px) {
    .right-fixed-box {
      right: 5px !important;
    }
  }
  @media (max-width: 575px) {
    .right-fixed-box {
      display: none;
    }
  }

  .m-top {
    margin-top: 106px;
  }

  &::after {
    display: block;
    clear: both;
    content: "";
  }
}

// 缺省页
.learning-default {
  .default-cont {
    padding: 160px 0;
    text-align: center;
    img {
      width: 153px;
    }
    p {
      margin-top: 30px;
      color: #abafbd;
      font-family: PingFangSC-Regular;
      font-size: 12px;
      line-height: 20px;
      a{
        color: #25c48b;
        &:hover{
          color: #28D899;
        }
      }
    }
  }
}

.pagination-box /deep/ .el-pagination {
  .btn-prev {
    background: #fff;
  }
  .btn-next {
    background: #fff;
  }
}

@media (max-width: 1199px) {
  .container {
    width: 100% !important;
    max-width: 100%;
  }
}
@media (max-width: 991px) {
  .container{
    width: 100% !important;
    max-width:100% !important;
    padding: 0 20px;
  }
}
</style>